import { render, staticRenderFns } from "./formScreenWaiting.vue?vue&type=template&id=3245bdfc&scoped=true"
import script from "./formScreenWaiting.vue?vue&type=script&lang=js"
export * from "./formScreenWaiting.vue?vue&type=script&lang=js"
import style0 from "./formScreenWaiting.vue?vue&type=style&index=0&id=3245bdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245bdfc",
  null
  
)

export default component.exports